import styled from 'styled-components';
import { type ClickableProps } from './Clickable.types';

const Clickable = styled.div<ClickableProps>`
  cursor: ${({ cursor, onClick }) => (cursor || onClick ? 'pointer' : 'default')};
  position: ${({ position }) => position || `relative`};
  width: ${({ width }) => width || `100%`};
  height: ${({ height }) => height || `auto`};
  top: ${({ top }) => top || `auto`};
  left: ${({ left }) => left || `auto`};
  right: ${({ right }) => right || `auto`};
`;

export default Clickable;
